import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://covqvovgmhnimcplztob.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNvdnF2b3ZnbWhuaW1jcGx6dG9iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkwNTQzNDAsImV4cCI6MjA4NDYzMDM0MH0.CPDt_-2YzPLsEz-OEX4cnI7iPuFsk6E9WSysJKRJ-bI';

const customStorage = {
  getItem: (key: string) => {
    let val = localStorage.getItem(key);
    if (!val) {
      val = sessionStorage.getItem(key);
    }
    console.log(`[Supabase Storage] getItem(${key}) ->`, val ? 'FOUND' : 'NULL');
    return val;
  },
  setItem: (key: string, value: string) => {
    const keep = localStorage.getItem('keep_logged_in');
    console.log(`[Supabase Storage] setItem(${key}) with keep_logged_in=${keep}`);
    // If they haven't answered or answered yes, put in localStorage. Only put in session if strictly false.
    if (keep === 'false') {
      sessionStorage.setItem(key, value);
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
      sessionStorage.removeItem(key);
    }
  },
  removeItem: (key: string) => {
    console.log(`[Supabase Storage] removeItem(${key})`);
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    storage: customStorage
  },
});
